// extracted by mini-css-extract-plugin
module.exports = {"container":"fullClickable_container___dkpn","invisibleElement":"fullClickable_invisibleElement__iTK2u"};